<template>
  <main class="p-5 mongo-cleaner">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 col-lg-9 col-xl-8 home-div">
          <div class="mongo-card shadow-sm rounded-4 p-4 p-lg-5">
            <div class="d-flex flex-column gap-1 mb-4">
              <h2 class="h5 mb-0">Mongo Cache Temizleme</h2>
              <p class="text-muted small mb-0">
                Koleksiyon seçin, silinecek veriyi önizleyin ve onaylayarak silin.
              </p>
            </div>
            <div class="mb-4">
              <label class="fw-semibold d-block mb-2">Mongo Koleksiyonu Seçin</label>
              <select
                  v-model="selectedCollection"
                  @change="onCollectionChange"
                  class="form-select"
              >
                <option disabled value="">Bir koleksiyon seçin</option>
                <option
                    v-for="collection in collections"
                    :key="collection"
                    :value="collection"
                >
                  {{ collection }}
                </option>
              </select>

              <small v-if="loadingCollections" class="text-muted d-block mt-1">
                Koleksiyonlar yükleniyor...
              </small>
            </div>

            <div v-if="schemaFields && schemaFields.length" class="mb-4">
              <label class="fw-semibold d-block mb-2">
                Koleksiyon Alanları (Schema)
              </label>

              <div class="schema-tags mt-1">
                <button
                    v-for="field in schemaFields"
                    :key="field.name"
                    type="button"
                    class="schema-badge"
                    @click="setKeyFromSchema(field.name)"
                >
                  {{ field.name }}
                </button>
              </div>

              <small class="text-muted d-block mt-2">
                Bir alan adına tıklarsanız aşağıdaki <strong>Key</strong> alanı otomatik doldurulur.
              </small>
            </div>

            <div class="mb-3">
              <label class="fw-semibold d-block mb-2">
                Silinecek veriyi bulmak için Key / Value girin
              </label>

              <div class="row g-3 align-items-center">
                <div class="col-12 col-md-5">
                  <div v-if="schemaFields && schemaFields.length">
                    <select
                        v-model="deleteKey"
                        class="form-select"
                    >
                      <option disabled value="">Key seçin (örn: user_id)</option>
                      <option
                          v-for="field in schemaFields"
                          :key="field.name"
                          :value="field.name"
                      >
                        {{ field.name }}
                      </option>
                      <option value="__custom">Diğer (manuel gir)</option>
                    </select>

                    <input
                        v-if="deleteKey === '__custom'"
                        v-model="customKey"
                        type="text"
                        placeholder="Key (örn: user_id)"
                        class="form-control mt-2"
                    />
                  </div>

                  <input
                      v-else
                      v-model="deleteKey"
                      type="text"
                      placeholder="Key (örn: user_id)"
                      class="form-control"
                  />
                </div>

                <div class="col-12 col-md-5">
                  <input
                      v-model="deleteValue"
                      type="text"
                      placeholder="Value (örn: 123456)"
                      class="form-control"
                  />
                </div>

                <div class="col-12 col-md-2 text-md-end">
                  <Button
                      label="Önizle"
                      class="w-100 mongo-btn-preview"
                      @click="handlePreview"
                      :disabled="!canPreview || loadingPreview"
                  />
                </div>
              </div>

              <small v-if="!selectedCollection" class="text-danger d-block mt-2">
                Önce bir koleksiyon seçmelisiniz.
              </small>
            </div>

            <!-- 4) Önizleme Sonucu -->
            <div v-if="previewMeta" class="mt-4">
              <div class="alert alert-info d-flex align-items-center gap-2 py-2">
                <i class="fa-light fa-circle-info"></i>
                <span class="small">
      Aşağıdaki koşula uyan kayıtları sileceksiniz. Lütfen kontrol edin.
    </span>
              </div>

              <!-- Özet "table" -->
              <div class="mongo-summary mt-3 mb-3">
                <div class="mongo-summary-row">
                  <span class="mongo-summary-label">Koleksiyon</span>
                  <span class="mongo-summary-value">
        <span class="badge bg-secondary">
          {{ previewMeta.collectionName }}
        </span>
      </span>
                </div>
                <div class="mongo-summary-row">
                  <span class="mongo-summary-label">Toplam Silinecek Kayıt</span>
                  <span class="mongo-summary-value">
        <span
            :class="[
            'badge',
            previewMeta.totalToDelete > 0 ? 'bg-danger' : 'bg-secondary'
          ]"
        >
          {{ previewMeta.totalToDelete }}
        </span>
      </span>
                </div>
                <div class="mongo-summary-row">
                  <span class="mongo-summary-label">Koşul</span>
                  <span class="mongo-summary-value">
        <code>
          {{ previewMeta.condition.key }} = {{ previewMeta.condition.value }}
        </code>
      </span>
                </div>
              </div>

              <!-- İsteğe bağlı: örnek dokümanlar -->
              <div v-if="previewDocuments.length" class="mongo-preview mt-3">
                <div class="mongo-preview-header d-flex justify-content-between align-items-center mb-2">
      <span class="fw-semibold small">
        Örnek Dokümanlar ({{ previewDocuments.length }})
      </span>
                  <span class="text-muted small">
        {{ deleting ? 'Siliniyor...' : 'Salt okunur önizleme' }}
      </span>
                </div>
                <pre class="mongo-preview-body small mb-0">
{{ formattedPreview }}
    </pre>
              </div>

              <div v-else class="text-muted small mt-2">
                Bu koşula ait örnek doküman gösterilmedi.
              </div>

              <div class="d-flex justify-content-end mt-3">
                <Button
                    label="Sil"
                    class="p-button-danger mongo-btn-delete"
                    @click="handleDelete"
                    :disabled="!canDelete || deleting"
                />
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import Swal from 'sweetalert2'

export default {
  name: 'MongoCacheCleaner',

  data() {
    return {
      collections: [],
      selectedCollection: '',
      schemaFields: [],
      deleteKey: '',
      deleteValue: '',
      customKey: '',
      previewMeta: null,
      previewDocuments: [],

      loadingCollections: false,
      loadingSchema: false,
      loadingPreview: false,
      deleting: false
    }
  },

  computed: {
    canPreview() {
      const key = this.deleteKey === '__custom' ? this.customKey : this.deleteKey

      return (
          !!this.selectedCollection &&
          !!key?.trim() &&
          !!this.deleteValue.trim()
      )
    },

    canDelete() {
      // Artık önizleme var mı ve silinecek kayıt sayısı > 0 mı?
      return (
          !!this.previewMeta &&
          this.previewMeta.totalToDelete > 0 &&
          !this.loadingPreview &&
          !this.deleting
      )
    },

    formattedPreview() {
      // Eğer sampleDocuments’i küçük JSON olarak göstermek istersen kullanırsın
      if (!this.previewDocuments || !this.previewDocuments.length) return ''
      try {
        return JSON.stringify(this.previewDocuments, null, 2)
      } catch (e) {
        return String(this.previewDocuments)
      }
    }
  },

  created() {
    this.fetchCollections()
  },

  methods: {
    setKeyFromSchema(fieldName) {
      this.deleteKey = fieldName
      this.customKey = ''
    },

    async fetchCollections() {
      this.loadingCollections = true
      try {
        const resp = await this.$appAxios.get('/admin/mongo/collections')
        this.collections = resp?.data?.response?.collections || []
      } catch (error) {
        console.error(error)
        Swal.fire({
          icon: 'error',
          title: 'Hata!',
          text: 'Koleksiyonlar alınırken bir hata oluştu.',
          confirmButtonText: 'Kapat'
        })
      } finally {
        this.loadingCollections = false
      }
    },

    async onCollectionChange() {
      this.schemaFields = []
      this.deleteKey = ''
      this.customKey = ''
      this.deleteValue = ''
      this.previewResult = null

      if (!this.selectedCollection) return

      this.loadingSchema = true
      try {
        const resp = await this.$appAxios.get(
            `/admin/mongo/collection/${this.selectedCollection}/schema`
        )

        this.schemaFields = resp?.data?.response?.fields || resp?.data || []
      } catch (error) {
        console.error(error)
        Swal.fire({
          icon: 'error',
          title: 'Hata!',
          text: 'Schema bilgisi alınırken bir hata oluştu.',
          confirmButtonText: 'Kapat'
        })
      } finally {
        this.loadingSchema = false
      }
    },

    async handlePreview() {
      if (!this.canPreview) return

      this.loadingPreview = true
      this.previewMeta = null
      this.previewDocuments = []

      const key = this.deleteKey === '__custom' ? this.customKey : this.deleteKey

      const body = {
        key: key.trim(),
        value: this.deleteValue.trim()
      }

      try {
        const resp = await this.$appAxios.post(
            `/admin/mongo/collection/${this.selectedCollection}/preview-delete`,
            body
        )

        const preview = resp?.data?.response

        if (!preview) {
          Swal.fire({
            icon: 'error',
            title: 'Hata!',
            text: 'Önizleme verisi alınamadı.',
            confirmButtonText: 'Kapat'
          })
          return
        }

        // Özet
        this.previewMeta = {
          collectionName: preview.collectionName,
          totalToDelete: preview.totalToDelete || 0,
          condition: preview.condition || {}
        }

        // Örnek dokümanlar
        this.previewDocuments = preview.sampleDocuments || []

        if (!this.previewMeta.totalToDelete) {
          Swal.fire({
            icon: 'info',
            title: 'Kayıt bulunamadı',
            text: 'Bu key/value ile eşleşen herhangi bir kayıt bulunamadı.',
            confirmButtonText: 'Tamam'
          })
        } else {
          Swal.fire({
            icon: 'success',
            title: 'Önizleme hazır',
            text: `Toplam ${this.previewMeta.totalToDelete} kayıt silinecek. Detayları aşağıda görebilirsiniz.`,
            confirmButtonText: 'Tamam'
          })
        }
      } catch (error) {
        console.error(error)
        this.previewMeta = null
        this.previewDocuments = []

        const errorMessage =
            error?.response?.data || 'Önizleme yapılırken bir hata oluştu.'

        Swal.fire({
          icon: 'error',
          title: 'Hata!',
          text: errorMessage,
          confirmButtonText: 'Kapat'
        })
      } finally {
        this.loadingPreview = false
      }
    },

    async handleDelete() {
      if (!this.canDelete) return

      const confirmResult = await Swal.fire({
        icon: 'warning',
        title: 'Emin misiniz?',
        text: 'Bu işlem geri alınamaz. Önizlemesini gördüğünüz tüm kayıtlar silinecek.',
        showCancelButton: true,
        confirmButtonText: 'Evet, sil',
        cancelButtonText: 'Vazgeç'
      })

      if (!confirmResult.isConfirmed) return

      this.deleting = true

      const key = this.deleteKey === '__custom' ? this.customKey : this.deleteKey

      try {
        const resp = await this.$appAxios.delete(
            `/admin/mongo/collection/${this.selectedCollection}/delete`,
            {
              data: {
                key: key.trim(),
                value: this.deleteValue.trim()
              }
            }
        )

        const message =
            resp?.data?.message || 'Silme işlemi başarıyla tamamlandı.'

        Swal.fire({
          icon: 'success',
          title: 'Başarılı!',
          text: message,
          confirmButtonText: 'Tamam'
        })

        this.previewMeta = null
        this.previewDocuments = []
      } catch (error) {
        console.error(error)

        const errorMessage =
            error?.response?.data || 'Silme işlemi sırasında bir hata oluştu.'

        Swal.fire({
          icon: 'error',
          title: 'Hata!',
          text: errorMessage,
          confirmButtonText: 'Kapat'
        })
      } finally {
        this.deleting = false
      }
    }
  }
}
</script>

<style scoped>

.form-control{
  padding-top: 15px !important;
  padding-left: 18px !important;
  padding-bottom: 15px !important;
}
.mongo-cleaner {
  background-color: #f8fafc;
  min-height: 100vh;
}

.mongo-card {
  background: #ffffff;
}

.schema-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
  max-height: 120px;
  overflow-y: auto;
}

.schema-badge {
  border: none;
  border-radius: 999px;
  padding: 0.25rem 0.75rem;
  font-size: 0.75rem;
  background-color: #e5e7eb;
  color: #111827;
  cursor: pointer;
  transition: background-color 0.15s ease, transform 0.1s ease;
}

.schema-badge:hover {
  background-color: #d4d4d8;
  transform: translateY(-1px);
}

.mongo-preview {
  border-radius: 0.75rem;
  border: 1px solid #e5e7eb;
  background: #0b1120;
  color: #e5e7eb;
  padding: 0.75rem 1rem;
}

.mongo-preview-header {
  border-bottom: 1px solid rgba(148, 163, 184, 0.4);
  padding-bottom: 0.25rem;
  margin-bottom: 0.5rem;
}

.mongo-preview-body {
  max-height: 260px;
  overflow: auto;
  margin: 0;
  white-space: pre;
}

.mongo-btn-preview {
  font-weight: 500;
}

.mongo-btn-delete {
  min-width: 140px;
  font-weight: 600;
}


.mongo-summary {
  border-radius: 0.75rem;
  border: 1px solid #e5e7eb;
  background: #f9fafb;
  padding: 0.75rem 1rem;
}

.mongo-summary-row {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.25rem 0;
  font-size: 0.85rem;
}

.mongo-summary-row + .mongo-summary-row {
  border-top: 1px dashed #e5e7eb;
  margin-top: 0.25rem;
  padding-top: 0.5rem;
}

.mongo-summary-label {
  color: #6b7280;
}

.mongo-summary-value {
  font-weight: 500;
}

</style>
